export default "__VITE_ASSET__B8NL0elx__"